(function () {
  'use strict';

  function initCZ9(root) {
    if (!root || root.dataset.cz9Initialized === 'v14') return;
    root.dataset.cz9Initialized = 'v14';

    var currencySymbol = root.getAttribute('data-currency-symbol') || '$';
    var cartAddUrl = root.getAttribute('data-cart-add-url') || '/cart/add.js';
    var cartUrl = root.getAttribute('data-cart-url') || '/cart';
    var cards = root.querySelectorAll('[data-offer-card]');
    var cartMessage = root.querySelector('[data-cz9-cart-message]');

    function showCartMessage(text, isError) {
      if (!cartMessage) return;
      cartMessage.hidden = !text;
      cartMessage.textContent = text || '';
      cartMessage.classList.toggle('is-error', !!isError);
    }

    /* =====================================================
       PACKAGE SELECT
    ====================================================== */
    if (cards.length) {
      var selected = root.querySelector('[data-offer-card].is-selected');

      if (!selected) {
        cards[0].classList.add('is-selected');
        var firstSelect = cards[0].querySelector('[data-select-offer]');
        if (firstSelect) firstSelect.setAttribute('aria-pressed', 'true');
      }

      cards.forEach(function (card) {
        var select = card.querySelector('[data-select-offer]');

        function selectCard() {
          cards.forEach(function (otherCard) {
            otherCard.classList.remove('is-selected');
            var otherSelect = otherCard.querySelector('[data-select-offer]');
            if (otherSelect) otherSelect.setAttribute('aria-pressed', 'false');
          });

          card.classList.add('is-selected');
          if (select) select.setAttribute('aria-pressed', 'true');
        }

        card.addEventListener('click', function (event) {
          if (
            event.target.closest('[data-quantity]') ||
            event.target.closest('.cz9-buy-btn')
          ) return;

          selectCard();
        });

        if (select) {
          select.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            selectCard();
          });
        }
      });
    }

    /* =====================================================
       QUANTITY + DISPLAY TOTAL
       Display price is only a preview.
       Real checkout price always comes from Shopify Variant.
    ====================================================== */
    cards.forEach(function (card) {
      var quantity = card.querySelector('[data-quantity]');
      if (!quantity) return;

      var input = quantity.querySelector('[data-qty-input]');
      var minus = quantity.querySelector('[data-qty-minus]');
      var plus = quantity.querySelector('[data-qty-plus]');
      var totalPrice = card.querySelector('[data-total-price]');
      var formQuantity = card.querySelector('[data-form-quantity]');
      if (!input) return;

      var shopifyPriceCents = parseInt(card.getAttribute('data-shopify-price-cents') || '', 10);
      var basePrice = !isNaN(shopifyPriceCents) ? shopifyPriceCents / 100 : NaN;

      if (isNaN(basePrice)) {
        var displayPrice = card.querySelector('.cz9-price');
        var priceText = displayPrice ? displayPrice.textContent : '';
        priceText = priceText.replace(/,/g, '');
        var match = priceText.match(/[\d]+(?:\.\d+)?/);
        basePrice = match ? parseFloat(match[0]) : NaN;
      }

      if (isNaN(basePrice)) {
        basePrice = parseFloat(card.getAttribute('data-base-price'));
      }
      if (isNaN(basePrice)) basePrice = 0;

      card.setAttribute('data-effective-price', basePrice.toFixed(2));

      function cleanQuantity(value) {
        var min = parseInt(input.getAttribute('min') || '1', 10);
        var max = parseInt(input.getAttribute('max') || '20', 10);
        var number = parseInt(value, 10);
        if (isNaN(number)) number = min;
        if (number < min) number = min;
        if (number > max) number = max;
        return number;
      }

      function formatPrice(value) {
        return currencySymbol + Number(value).toFixed(2);
      }

      function update(value) {
        var clean = cleanQuantity(value);
        input.value = clean;
        if (formQuantity) formQuantity.value = clean;
        if (minus) minus.disabled = clean <= parseInt(input.getAttribute('min') || '1', 10);
        if (plus) plus.disabled = clean >= parseInt(input.getAttribute('max') || '20', 10);

        if (totalPrice) {
          totalPrice.textContent = formatPrice(basePrice * clean);
          totalPrice.classList.remove('is-updating');
          void totalPrice.offsetWidth;
          totalPrice.classList.add('is-updating');
        }
      }

      if (minus) {
        minus.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          update(parseInt(input.value || '1', 10) - 1);
        });
      }

      if (plus) {
        plus.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          update(parseInt(input.value || '1', 10) + 1);
        });
      }

      input.addEventListener('change', function () {
        update(input.value);
      });

      update(input.value);
    });

    /* =====================================================
       ADD REAL SHOPIFY VARIANT TO CART -> REDIRECT TO CART
    ====================================================== */
    root.querySelectorAll('[data-cz9-cart-form]').forEach(function (form) {
      form.addEventListener('submit', async function (event) {
        event.preventDefault();

        var button = form.querySelector('[data-cz9-cart-button]');
        var label = form.querySelector('[data-cz9-button-label]');
        var originalLabel = label ? label.textContent : '';

        if (button) button.disabled = true;
        if (label) label.textContent = 'ADDING TO CART…';
        showCartMessage('', false);

        try {
          var response = await fetch(cartAddUrl, {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: new FormData(form)
          });

          var result = await response.json();

          if (!response.ok) {
            throw new Error(result.description || result.message || 'Unable to add this option to cart.');
          }

          window.location.assign(cartUrl);
        } catch (error) {
          showCartMessage(error.message || 'Unable to add this option to cart. Please try again.', true);
          if (button) button.disabled = false;
          if (label) label.textContent = originalLabel;
        }
      });
    });

    root.querySelectorAll('[data-cz9-unbound]').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        showCartMessage(
          button.getAttribute('data-unbound-message') ||
          'This offer must be connected to a Shopify product or variant before checkout.',
          true
        );
      });
    });
  }

  function initAllCZ9() {
    document.querySelectorAll('[data-cz9-section]').forEach(initCZ9);
  }

  /*
    Theme Editor can execute a section asset more than once while a section is
    re-rendered. Keep one global lifecycle listener only. Each live section root
    is initialized once via data-cz9-initialized="v14".
  */
  if (!window.__CZ9_V14_GLOBAL_BOUND__) {
    window.__CZ9_V14_GLOBAL_BOUND__ = true;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllCZ9, { once: true });
    } else {
      initAllCZ9();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = null;

      if (event.target.matches && event.target.matches('[data-cz9-section]')) {
        root = event.target;
      }

      if (!root && event.target.querySelector) {
        root = event.target.querySelector('[data-cz9-section]');
      }

      if (root) initCZ9(root);
    });
  } else {
    /* If Shopify re-executes this asset, initialize only newly inserted roots. */
    initAllCZ9();
  }
})();
